import React from "react";
import styled, { keyframes } from "styled-components";

const Ripples = () => {
  return (
    <Container>
      <div />
      <div />
    </Container>
  );
};

export default Ripples;

const ani = keyframes`
0% {
  top: 84px;
  left: 84px;
  width: 0;
  height: 0;
  opacity: 1;
}
100% {
  top: -3px;
  left: -3px;
  width: 174px;
  height: 174px;
  opacity: 0;
}
`;

const Container = styled.div`
  position: relative;
  width: 171px;
  margin: 0 auto;
  height: 171px;
  div {
    position: absolute;
    border: 4px solid #2f7de1;
    opacity: 1;
    border-radius: 50%;
    animation: ${ani} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
`;
